export default __webpack_public_path__ + "static/media/detail_1.13af7c05.jpg";